import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getCoverageRows } from "./coverage-rows";

export const metadata = {
  tableType: "Coverage",
  displayName: "Coverage",
  getRows: (bundle: FhirBundleSdk) => getCoverageRows({ bundle }),
};
